<template>
    <div id="year-report-wrapper">
      <div v-title data-title="2023神灯个人年度报告"></div>
      <div class="page-share" @click="handleShare">
        <van-icon 
          name="share-o"
          size="35"
          color="#fff" 
        />
      </div>
      <div v-if="!loading && !loadingData" class="year-report-content">
          <Page1
              v-if="curPage === 1"
              :reportData="reportData"
              @next="handleNext"
              @pre="handlePre"
          />
          <Page2
              v-if="curPage === 2"
              :reportData="reportData"
              @next="handleNext"
              @pre="handlePre"
          />
          <Page3
              v-if="curPage === 3 && (reportData.postNum || reportData.chatNum)"
              :reportData="reportData"
              @next="handleNext"
              @pre="handlePre"
          />
          <Page4
              v-if="curPage === page4"
              :reportData="reportData"
              @next="handleNext"
              @pre="handlePre"
          />
          <Page5 
            v-if="curPage === page5" 
            :reportData="reportData" 
            @pre="handlePre" />
          <Page6
            v-if="curPage === page6" 
            :reportData="reportData" 
            @pre="handlePre" />
          <Page7
            v-if="curPage === page7 && reportData.award && reportData.award.length" 
            :reportData="reportData" 
            @pre="handlePre" />
          <Page8
            v-if="curPage === page8 && reportData.badge && reportData.badge.length" 
            :reportData="reportData" 
            @pre="handlePre" />
          <Page9
            v-if="curPage === page9" 
            :reportData="reportData" 
            @pre="handlePre" />
          <Page10
            v-if="curPage === page10" 
            :reportData="reportData" 
            @pre="handlePre" />
          <div v-if="curPage !== totalPage && curPage !== 1" @click="handleNext" class="slide">
              <i class="iconfont icon-arrow slide-arrow"></i>
          </div>
      </div>
      <div v-else class="load">
        <div class="load-content">
          <div class="load-content-tip">正在进入个人年度报告...</div>
          <van-progress :percentage="percent" stroke-width="8" />
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import './assets/font/iconfont.css';
import './assets/font/iconfont.js';
import Page1 from './components/page1.vue';
import Page2 from './components/page2.vue';
import Page3 from './components/page3.vue';
import Page4 from './components/page4.vue';
import Page5 from './components/page5.vue';
import Page6 from './components/page6.vue';
import Page7 from './components/page7.vue';
import Page8 from './components/page8.vue';
import Page9 from './components/page9.vue';
import Page10 from './components/page10.vue';
import api from '../../api';

export default {
    name: 'YearSummary',
    components: {
        Page1,
        Page2,
        Page3,
        Page4,
        Page5,
        Page6,
        Page7,
        Page8,
        Page9,
        Page10
    },
    data() {
        return {
          curPage: 1,
          reportData: {},
          loading: false,
          loadingData: false,
          percent: 0,
        };
    },
    computed: {
      ...mapState(['userInfo']),
      totalPage() {
        let a = 10;
        if (!this.reportData?.postNum && !this.reportData.chatNum) {
          a = a - 1;
        }
        if (!this.reportData.award?.length) {
          a = a - 1;
        }
        if (!this.reportData.badge?.length) {
          a = a - 1;
        }
        return a;
      },
      page4() {
        let page4 = 4;
        if (!this.reportData?.postNum && !this.reportData.chatNum) {
          page4 = page4 - 1;
        }
        return page4
      },
      page5() {
        let page5 = 5;
        if (!this.reportData?.postNum && !this.reportData.chatNum) {
          page5 = page5 - 1;
        }
        return page5
      },
      page6() {
        let page6 = 6;
        if (!this.reportData?.postNum && !this.reportData.chatNum) {
          page6 = page6 - 1;
        }
        console.log(page6)
        return page6
      },
      page7() {
        let page7 = 7;
        if (!this.reportData?.postNum && !this.reportData.chatNum) {
          page7 = page7 - 1;
        }
        return page7
      },
      page8() {
        let page8 = 8;
        if (!this.reportData?.postNum && !this.reportData.chatNum) {
          page8 = page8 - 1;
        }
        if (!this.reportData?.award?.length) {
          page8 = page8 - 1;
        }
        return page8
      },
      page9() {
        let page9 = 9;
        if (!this.reportData?.postNum && !this.reportData.chatNum) {
          page9 = page9 - 1;
        }
        if (!this.reportData?.award?.length) {
          page9 = page9 - 1;
        }
        if (!this.reportData?.badge?.length) {
          page9 = page9 - 1;
        }
        return page9
      },
      page10() {
        let page10 = 10;
        if (!this.reportData.postNum && !this.reportData.chatNum) {
          page10 = page10 - 1;
        }
         if (!this.reportData.award.length) {
          page10 = page10 - 1;
        }
        if (!this.reportData.badge.length) {
          page10 = page10 - 1;
        }
        return page10
      },
    },
    created() {
        this.hanlePreLoad()
        this.getReportDetail(this.$route?.query?.erp)

        let box = document.querySelector('body') // 监听对象
        box.style.overflow = 'hidden'
        let startTime = '' // 触摸开始时间
        let startDistanceX = '' // 触摸开始X轴位置
        let startDistanceY = '' // 触摸开始Y轴位置
        let endTime = '' // 触摸结束时间
        let endDistanceX = '' // 触摸结束X轴位置
        let endDistanceY = '' // 触摸结束Y轴位置
        let moveTime = '' // 触摸时间
        let moveDistanceX = '' // 触摸移动X轴距离
        let moveDistanceY = '' // 触摸移动Y轴距离
        box.addEventListener("touchstart", (e) => {
            startTime = new Date().getTime()
            startDistanceX = e.touches[0].screenX
            startDistanceY = e.touches[0].screenY
        })
        box.addEventListener("touchend", (e) => {
            endTime = new Date().getTime()
            endDistanceX = e.changedTouches[0].screenX
            endDistanceY = e.changedTouches[0].screenY
            moveTime = endTime - startTime
            moveDistanceX = startDistanceX - endDistanceX
            moveDistanceY = startDistanceY - endDistanceY
            // 判断滑动距离超过40 且 时间小于500毫秒
            if ((Math.abs(moveDistanceX) > 20 || Math.abs(moveDistanceY) > 20) && moveTime < 500) {
                // 判断X轴移动的距离是否大于Y轴移动的距离
                if (Math.abs(moveDistanceX) > Math.abs(moveDistanceY)) {
                // 左右
                  if (moveDistanceX > 0) {
                    this.handlePre()
                  } else {
                    this.handleNext()
                  }
                } else {
                // 上下
                  if (moveDistanceY > 0) {
                    this.handleNext()
                  } else {
                    this.handlePre()
                  }
                }
            }
        })

        let scrollFunc = (e) => {
            e = e || window.event;
            if (e.wheelDelta) {
                //判断浏览器IE，谷歌滑轮事件
                if (e.wheelDelta > 2) {
                    //当滑轮向上滚动时
                    this.handlePre();
                }
                if (e.wheelDelta < -2) {
                    //当滑轮向下滚动时
                    this.handleNext();
                }
            } else if (e.detail) {
                //Firefox滑轮事件
                if (e.detail > 0) {
                    //当滑轮向下滚动时
                    this.handlePre();
                }
                if (e.detail < 0) {
                    //当滑轮向上滚动时
                    this.handleNext();
                }
            }
        };
        if (document.attachEvent) {
            document.attachEvent('onmousewheel', this.throttle(scrollFunc));
        }
        //Firefox使用addEventListener添加滚轮事件
        if (document.addEventListener) {
            //firefox
            document.addEventListener(
                'DOMMouseScroll',
                this.throttle(scrollFunc),
                false,
            );
        }
        //Safari与Chrome属于同一类型
        window.onmousewheel = document.onmousewheel = this.throttle(scrollFunc);
    },
    methods: {
        handleShare() {
          const url = 'http://sd.jd.com/yearReport?isHideShareButton=1'
          const options = {
            shareData: {
              title: '2023年度报告',
              content: '快来查看你的神灯专属2023年度报告吧!',
              url,
              icon: 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-02-28-17-07uAVeSgG0YYEUaxf.png',
            },
            typeList: ['JDMESession', 'CopyLink'],
            callback: function() {
            }
          }
          window.jme.share.shareCustom(options)
        },
        throttle(fn, wait = 1000) {
            // 上一次执行 fn 的时间
            let previous = 0;
            // 将 throttle 处理结果当作函数返回
            return function(...args) {
                // 获取当前时间，转换成时间戳，单位毫秒
                let now = +new Date();
                // 将当前时间和上一次执行函数的时间进行对比
                // 大于等待时间就把 previous 设置为当前时间并执行函数 fn
                if (now - previous > wait) {
                    previous = now;
                    fn.apply(this, args);
                }
            };
        },
        handleNext() {
          console.log(this.curPage, this.totalPage)
            if (this.curPage < this.totalPage) {
                this.curPage += 1;
            }
        },
        handlePre() {
            if (this.curPage > 1) {
                this.curPage -= 1;
            }
        },
        getReportDetail(erp) {
          this.loadingData = true;
          const isJM = window.navigator.userAgent.indexOf('JDME') > -1;
          const apiUrl = isJM ? api.getMobilReportDetail : api.getReportDetail;
          
          apiUrl(erp).then(res => {
            const { code, data } = res;
            if (code === 200) {
              this.reportData = data[0];
              this.$nextTick(() => {
                this.loadingData = false;
              })
            }
          }).catch((e) => {
            if (e.code === 401) {
              window.location.href = 'http://ssa.jd.com/sso/login?ReturnUrl=' + encodeURIComponent(window.location.href);
            }
          })
        },
        preloadImg() {
          // const imgs = [
          //   'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-21-16-07yQGMDWztEvtzTNc.jpg',
          //   'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-21-17-56EQSc21FRIaSmv95X.jpg',
          //   'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-21-16-47sJv21hdZeceTadSl.jpg',
          //   'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-16-52852y9f12nENT9TtYw.jpg',
          //   'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-21-19-43dfZbVtjvcwq8Vr7.jpg',
          //   'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-00NOGn9sW0raqTu8U.jpg',
          //   'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-54sg54zTkmQQy54sf9y.png',
          //   'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-14-29Qep12MUJFI8h0L25B.jpg',
          //   'https://storage.360buyimg.com/iast-agent/reportBg9.jpg',
          //   'https://storage.360buyimg.com/iast-agent/titleBg.png'
          // ]
          const imgs = [
            'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-17-0412qF9wrScvLis07c.jpg',
            'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-15-29G6RrBmSO8CcHZjN.jpg',
            'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-15-49KjOW7fHpe68rAJ9.jpg',
            'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-15-53Z8e8nEZOD0sGcmi.jpg',
            'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-15-59jc28gmoG59QRfeWOE.jpg',
            'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-16-16Ty161616uS6ejfZpgf.jpg',
            'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-16-22bys22mAcOKqDTy8J.jpg',
            'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-17-567h6MhuZITuoSq5R.jpg',
            'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-18-53RdmFtktHBO53uBtO.jpg',
            'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-16-43TX4Lu28VZmmrLx0U.jpg',
            'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-16-49ctUlfjlrqySQXJA.jpg',
            'https://storage.360buyimg.com/iast-agent/titleBg.png'
          ]
          imgs.forEach(item => {
            const img = document.createElement('img')
            img.src = item
          })
        },
        hanlePreLoad() {
          this.loading = true
          this.preloadImg()
          const interval = setInterval(() => {
            this.percent += 1
            if (this.percent >= 100) {
              clearInterval(interval)
              this.loading = false
            }
          }, 25)
        }
    },
};
</script>

<style lang="less" scoped>
#year-report-wrapper {
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100%;
    // background: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-20-16-21lYeQezB12xwh6Cno.jpeg');
    // background-size: cover;
    .load {
      // background:rgba(173, 225, 247, 0.4);
      background: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-17-0412qF9wrScvLis07c.jpg');
      background-size: 100% 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .load-content {
        width: 70%;
      }
      .load-content-tip {
        margin-bottom: 20px;
        font-size: 16px;
        font-style: oblique;
        color: #FAFAD7;
        font-weight: bold;
      }
    }
    .page-share {
      position: fixed;
      right: 20px;
      top: 20px;
      z-index: 1000;
    }
    .year-report-content {
      width: 100%;
      max-width: 540px;
    }
    .slide {
        -webkit-animation: slideMove 1.5s linear 0s infinite;
        animation: slideMove 1.5s linear 0s infinite;
        z-index: 30;
        font-size: 0.5rem;
        cursor: pointer;
    }
    @keyframes slideMove {
        0% {
            transform: translateY(0.6rem);
            opacity: 0;
        }
        50% {
            transform: translateY(0.3rem);
            opacity: 0.8;
        }
        100% {
            transform: translateY(0);
            opacity: 0;
        }
    }
    .slide-arrow {
        display: inline-block;
        font-size: 0.8rem;
        position: fixed;
        bottom: 1rem;
        left: 50%;
        transform: translateX(-50%);
        color: rgb(255, 255, 255);
    }
}
/deep/ .van-progress__portion {
  background: #FAFAD7;
}
/deep/ .van-progress__pivot {
  background-color: #FAFAD7;
  color: #000;
}
</style>
